if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      static get observedAttributes() {
        return super.observedAttributes.concat([
          'data-trigger-open',
          'data-repeat-open',
        ]);
      }

      constructor() {
        super();

        this.openTimer = null;
        this.scrollHandler = null;
        this.lastHandledNewsletterSubmittedAt = null;

        this.handleNewsletterSuccess =
          this.handleNewsletterSuccess.bind(this);

        this.handleEscapeKey =
          this.handleEscapeKey.bind(this);
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();



        this.triggerOpen =
          this.dataset.triggerOpen;

        this.repeatOpen =
          this.dataset.repeatOpen;

        this.cookieName =
          'sleektheme:popup';

        this.emailSubmittedKey =
          'bs_welcome10_email_submitted';

        this.discountAppliedKey =
          'bs_welcome10_discount_applied';

this.couponDismissedKey =
  'bs_welcome10_coupon_dismissed_at';

this.popupDismissedKey =
  'bs_welcome10_popup_dismissed';

this.couponReminderDelay =
  24 * 60 * 60 * 1000;

this.createReopenTrigger();

        this.captureOriginalContent();

        window.addEventListener(
          'bs:newsletter-success',
          this.handleNewsletterSuccess
        );

        window.addEventListener(
          'keydown',
          this.handleEscapeKey
        );

        window.FoxTheme.DOMready(() => {
          /*
           * Process a buffered Newsletter result if the form
           * initialized before this custom element.
           */
          if (window.bsNewsletterSuccess) {
            this.handleNewsletterSuccess({
              detail: window.bsNewsletterSuccess,
            });

            return;
          }

          this.handleOpen();
        });

        /*
         * Bind the delegated Coupon click handler only once.
         */
        if (
          this.dataset.couponDelegateBound !==
          'true'
        ) {
          this.dataset.couponDelegateBound =
            'true';

          window.FoxTheme.utils.addEventDelegate({
            context: this,
            selector: '.btn-apply-coupon-code',
            handler: async (event, target) => {
              event.preventDefault();

              const code = target.dataset.code;

              if (code) {
                await this.applyCoupon(
                  code,
                  target
                );
              }
            },
          });
        }

        this.bindDismissEvents();
      }

      disconnectedCallback() {
        window.removeEventListener(
          'bs:newsletter-success',
          this.handleNewsletterSuccess
        );

        window.removeEventListener(
          'keydown',
          this.handleEscapeKey
        );

        this.clearScheduledOpen();
        this.clearScrollTrigger();

        if (
          typeof super.disconnectedCallback ===
          'function'
        ) {
          super.disconnectedCallback();
        }
      }

      prepareToShow() {
        super.prepareToShow();
        this.setRepeatOpen();
      }

      captureOriginalContent() {
        const headingWrapper = this.querySelector(
          '[data-popup-email-heading]'
        );

        const heading = headingWrapper
          ? headingWrapper.querySelector(
              'h1, h2, h3, h4, h5, h6'
            )
          : null;

        const textBlocks = this.querySelectorAll(
          '[data-popup-email-text]'
        );

        if (
          heading &&
          !heading.dataset.originalText
        ) {
          heading.dataset.originalText =
            heading.textContent.trim();
        }

        textBlocks.forEach((textBlock) => {
          if (
            !textBlock.dataset.originalHtml
          ) {
            textBlock.dataset.originalHtml =
              textBlock.innerHTML;
          }
        });
      }

createReopenTrigger() {
  if (this.reopenTrigger) return;

  const trigger = document.createElement('div');

  trigger.className = 'bs-popup-reopen';
  trigger.hidden = true;

  trigger.innerHTML = `
    <button
      type="button"
      class="bs-popup-reopen__dismiss"
      aria-label="Hide special offer"
    >
      ×
    </button>

    <button
      type="button"
      class="bs-popup-reopen__open"
      aria-label="Open special offer"
    >
      Special Offer
    </button>
  `;

  document.body.appendChild(trigger);

  this.reopenTrigger = trigger;

  const dismissButton = trigger.querySelector(
    '.bs-popup-reopen__dismiss'
  );

  const openButton = trigger.querySelector(
    '.bs-popup-reopen__open'
  );

  dismissButton?.addEventListener('click', () => {
    trigger.hidden = true;
  });

  openButton?.addEventListener('click', () => {
    trigger.hidden = true;
    this.show();
  });

if (
  this.popupDismissed &&
  !this.discountApplied
) {
  trigger.hidden = false;
}  

}

showReopenTrigger() {
  if (
    !this.reopenTrigger ||
    this.discountApplied
  ) {
    return;
  }

  this.reopenTrigger.hidden = false;
}

      bindDismissEvents() {
        const closeTargets = this.querySelectorAll(
          '.drawer__close-btn, .fixed-overlay'
        );

        closeTargets.forEach((target) => {
          if (
            target.dataset.couponBound ===
            'true'
          ) {
            return;
          }

          target.dataset.couponBound = 'true';

target.addEventListener(
  'click',
  () => {
    this.handleCouponDismiss();

    if (!this.discountApplied) {
      this.safeSet(
        this.popupDismissedKey,
        'true'
      );
    }

    setTimeout(() => {
      this.showReopenTrigger();
    }, 150);
  }
);
        });
      }

      handleEscapeKey(event) {
        if (
          event.key !== 'Escape' ||
          this.hasAttribute('hidden')
        ) {
          return;
        }

        this.handleCouponDismiss();
      }

      safeGet(key) {
        try {
          return localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      safeSet(key, value) {
        try {
          localStorage.setItem(key, value);
        } catch (error) {
          console.warn(
            'Unable to save the popup status.',
            error
          );
        }
      }

      safeRemove(key) {
        try {
          localStorage.removeItem(key);
        } catch (error) {
          console.warn(
            'Unable to remove the popup status.',
            error
          );
        }
      }

      get emailSubmitted() {
        return (
          this.safeGet(
            this.emailSubmittedKey
          ) === 'true'
        );
      }

      get discountApplied() {
        return (
          this.safeGet(
            this.discountAppliedKey
          ) === 'true'
        );
      }

get popupDismissed() {
  return (
    this.safeGet(
      this.popupDismissedKey
    ) === 'true'
  );
}

      get couponDismissedRecently() {
        const dismissedAt = Number(
          this.safeGet(
            this.couponDismissedKey
          ) || 0
        );

        return (
          dismissedAt > 0 &&
          Date.now() - dismissedAt <
            this.couponReminderDelay
        );
      }

      clearScheduledOpen() {
        if (!this.openTimer) {
          return;
        }

        window.clearTimeout(this.openTimer);
        this.openTimer = null;
      }

      clearScrollTrigger() {
        if (!this.scrollHandler) {
          return;
        }

        window.removeEventListener(
          'scroll',
          this.scrollHandler
        );

        this.scrollHandler = null;
      }

      scheduleOpen(callback) {
        this.clearScheduledOpen();
        this.clearScrollTrigger();

        switch (this.triggerOpen) {
          case 'delay':
            this.openTimer =
              window.setTimeout(() => {
                this.openTimer = null;
                callback();
              }, 5000);
            break;

          case 'scroll_down':
            this.triggerAfterScroll(
              700,
              callback
            );
            break;

          default:
            callback();
            break;
        }
      }

      handleOpen() {
        if (Shopify.designMode) {
          return;
        }

        /*
         * Do not automatically display either state after the
         * discount has been successfully applied.
         */
        if (this.discountApplied) {
          return;
        }

        /*
         * If an email was submitted but the Coupon was not
         * applied, respect the 24-hour dismissal period.
         */
        if (this.emailSubmitted) {
          if (this.couponDismissedRecently) {
            return;
          }

          this.scheduleOpen(() => {
            if (this.showCouponState()) {
              this.show();
            }
          });

          return;
        }

        /*
         * Visitors who have not submitted an email continue
         * to use Sleek's original repeat-opening rules.
         */
        const savedData =
          FoxTheme.utils.getStorage(
            this.cookieName
          );

        if (
          savedData &&
          savedData.opened
        ) {
          return false;
        }

        this.showEmailState();

        this.scheduleOpen(() => {
          this.show();
        });
      }

      handleNewsletterSuccess(event) {
        const detail =
          event && event.detail
            ? event.detail
            : {};

        const source =
          detail.source || 'default';

        const submittedAt =
          Number(detail.submittedAt) || 0;

  const discountAlreadyApplied =
  detail.discountAlreadyApplied === true ||
  this.discountApplied;

        /*
         * Ignore only the exact same buffered/live event.
         * A later Footer submission on the same page is allowed.
         */
        if (
          submittedAt > 0 &&
          submittedAt ===
            this.lastHandledNewsletterSubmittedAt
        ) {
          window.bsNewsletterSuccess = null;
          return;
        }

        if (
          source !== 'popup' &&
          source !== 'footer'
        ) {
          return;
        }

        if (submittedAt > 0) {
          this.lastHandledNewsletterSubmittedAt =
            submittedAt;
        }



        this.safeSet(
          this.emailSubmittedKey,
          'true'
        );

        /*
         * A new Newsletter submission should immediately show
         * the Coupon and clear a previous dismissal time.
         */
        this.safeRemove(
          this.couponDismissedKey
        );

        const couponStateReady =
          this.showCouponState();

        if (!couponStateReady) {
          console.error(
            'The subscription popup discount code block could not be found.'
          );

          window.bsNewsletterSuccess = null;
          return;
        }

        if (discountAlreadyApplied) {
  const button = this.querySelector(
    '.btn-apply-coupon-code'
  );

  if (button) {
    button.textContent = 'Applied ✓';
    button.dataset.applied = 'true';
    button.disabled = true;

    let status =
      button.parentElement.querySelector(
        '.bs-coupon-apply-status'
      );

    if (!status) {
      status = document.createElement('p');
      status.className =
        'bs-coupon-apply-status';
      status.setAttribute(
        'aria-live',
        'polite'
      );

      button.insertAdjacentElement(
        'afterend',
        status
      );
    }

    status.textContent =
      'You’re subscribed. Your 10% discount is already active and will remain available at checkout.';
  }
}

        this.clearScheduledOpen();
        this.clearScrollTrigger();
        this.show();

        window.bsNewsletterSuccess = null;
        window.isNewsletterModalShow = true;
      }

      showEmailState() {
        const headingWrapper = this.querySelector(
          '[data-popup-email-heading]'
        );

        const heading = headingWrapper
          ? headingWrapper.querySelector(
              'h1, h2, h3, h4, h5, h6'
            )
          : null;

        const textBlocks = Array.from(
          this.querySelectorAll(
            '[data-popup-email-text]'
          )
        );

        const emailForm = this.querySelector(
          '[data-popup-email-form]'
        );

        const couponState = this.querySelector(
          '[data-popup-coupon-state]'
        );

        if (
          heading &&
          heading.dataset.originalText
        ) {
          heading.textContent =
            heading.dataset.originalText;
        }

        textBlocks.forEach((textBlock) => {
          if (
            textBlock.dataset.originalHtml
          ) {
            textBlock.innerHTML =
              textBlock.dataset.originalHtml;
          }

          textBlock.classList.remove(
            'hidden'
          );
        });

        if (emailForm) {
          emailForm.classList.remove('hidden');
        }

        if (couponState) {
          couponState.classList.add('hidden');
          couponState.setAttribute(
            'hidden',
            'hidden'
          );
        }

        delete this.dataset.couponState;
      }

      showCouponState() {
        const headingWrapper = this.querySelector(
          '[data-popup-email-heading]'
        );

        const heading = headingWrapper
          ? headingWrapper.querySelector(
              'h1, h2, h3, h4, h5, h6'
            )
          : null;

        const textBlocks = Array.from(
          this.querySelectorAll(
            '[data-popup-email-text]'
          )
        );

        const description =
          textBlocks[0] || null;

        const additionalTextBlocks =
          textBlocks.slice(1);

        const emailForm = this.querySelector(
          '[data-popup-email-form]'
        );

        const couponState = this.querySelector(
          '[data-popup-coupon-state]'
        );

        if (!couponState) {
          return false;
        }

        if (heading) {
          heading.textContent =
            'Your 10% Discount Is Ready';
        }

        if (description) {
          description.innerHTML =
            '<p>Click the coupon below to apply it to your order.</p>';

          description.classList.remove(
            'hidden'
          );
        }

        additionalTextBlocks.forEach(
          (textBlock) => {
            textBlock.classList.add(
              'hidden'
            );
          }
        );

        if (emailForm) {
          emailForm.classList.add('hidden');
        }

        couponState.classList.remove('hidden');
        couponState.removeAttribute('hidden');

        this.dataset.couponState = 'true';

        return true;
      }

      handleCouponDismiss() {
        const isCouponState =
          this.dataset.couponState ===
          'true';

        if (
          !isCouponState ||
          this.discountApplied
        ) {
          return;
        }

        this.safeSet(
          this.couponDismissedKey,
          String(Date.now())
        );
      }

      triggerAfterScroll(
        offset = 500,
        trigger
      ) {
        const start =
          window.pageYOffset || 0;

        this.scrollHandler = () => {
          const scrollTop =
            window.pageYOffset ||
            document.documentElement
              .scrollTop ||
            document.body.scrollTop ||
            0;

          if (
            scrollTop - start <= offset
          ) {
            return;
          }

          this.clearScrollTrigger();
          trigger();
        };

        window.addEventListener(
          'scroll',
          this.scrollHandler,
          {
            passive: true,
          }
        );
      }

async applyCoupon(code, button) {
  if (!code || !button || button.disabled) {
    return;
  }

  const originalText =
    button.dataset.originalText ||
    button.textContent.trim();

  const normalizedCode =
    code.trim().toLowerCase();

  const root =
    window.Shopify?.routes?.root || '/';

  let status =
    button.parentElement.querySelector(
      '.bs-coupon-apply-status'
    );

  if (!status) {
    status = document.createElement('p');
    status.className = 'bs-coupon-apply-status';
    status.setAttribute('aria-live', 'polite');

    button.insertAdjacentElement(
      'afterend',
      status
    );
  }

  const cartHasDiscount = (cart) => {
    if (!cart || typeof cart !== 'object') {
      return false;
    }

    const codeExists = Array.isArray(
      cart.discount_codes
    ) && cart.discount_codes.some((discount) => {
      return (
        typeof discount.code === 'string' &&
        discount.code.trim().toLowerCase() ===
          normalizedCode &&
        discount.applicable !== false
      );
    });

    const cartDiscountExists = Array.isArray(
      cart.cart_level_discount_applications
    ) && cart.cart_level_discount_applications.some(
      (application) => {
        const discountApplication =
          application?.discount_application ||
          application;

        return (
          typeof discountApplication?.title ===
            'string' &&
          discountApplication.title
            .trim()
            .toLowerCase() === normalizedCode
        );
      }
    );

    const itemDiscountExists = Array.isArray(
      cart.items
    ) && cart.items.some((item) => {
      return (
        Array.isArray(item.discounts) &&
        item.discounts.some((discount) => {
          return (
            typeof discount.title === 'string' &&
            discount.title
              .trim()
              .toLowerCase() === normalizedCode
          );
        })
      );
    });

    return (
      codeExists ||
      cartDiscountExists ||
      itemDiscountExists
    );
  };

  const showAppliedState = () => {
    button.textContent = 'Applied ✓';
    button.dataset.applied = 'true';
    button.disabled = true;

    status.textContent =
      'Your discount has been applied and will remain active at checkout.';

this.safeSet(
  this.discountAppliedKey,
  'true'
);

this.safeRemove(
  this.couponDismissedKey
);

this.safeRemove(
  this.popupDismissedKey
);

if (this.reopenTrigger) {
  this.reopenTrigger.hidden = true;
}

  };

  button.dataset.originalText = originalText;
  button.disabled = true;
  status.textContent = '';

  try {
    /*
     * Check whether the discount is already active.
     */
    const currentCartResponse = await fetch(
      root + 'cart.js',
      {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      }
    );

    if (currentCartResponse.ok) {
      const currentCart =
        await currentCartResponse.json();

      if (cartHasDiscount(currentCart)) {
        showAppliedState();
        return;
      }
    }

    /*
     * Apply the discount when it is not already active.
     */
    const updateResponse = await fetch(
      root + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          discount: code,
        }),
      }
    );

    if (!updateResponse.ok) {
      throw new Error(
        'Unable to apply the discount.'
      );
    }

const updatedCart =
  await updateResponse.json();

if (cartHasDiscount(updatedCart)) {
  showAppliedState();
  return;
}

/*
 * Shopify can save the discount code to an empty cart,
 * but it cannot mark it as applicable until an eligible
 * item is added.
 */
if (
  updatedCart.item_count === 0 &&
  Array.isArray(updatedCart.discount_codes) &&
  updatedCart.discount_codes.some((discount) => {
    return (
      typeof discount.code === 'string' &&
      discount.code
        .trim()
        .toLowerCase() === normalizedCode
    );
  })
) {
  button.textContent = 'Code Saved ✓';
  button.dataset.applied = 'pending';
  button.disabled = true;

  status.textContent =
    'Add an eligible item to your cart, and your 10% discount will apply automatically.';

this.safeSet(
  this.discountAppliedKey,
  'true'
);

this.safeRemove(
  this.couponDismissedKey
);

this.safeRemove(
  this.popupDismissedKey
);

if (this.reopenTrigger) {
  this.reopenTrigger.hidden = true;
}

return;

}

throw new Error(
  'The discount is not applicable to the current cart.'
);
  } catch (error) {
    button.disabled = false;
    button.textContent = originalText;

    status.textContent =
      `We could not apply the discount automatically. Please use code ${code} at checkout.`;

    console.error(
      'Discount application failed:',
      error
    );
  }
}

      setRepeatOpen() {
        if (Shopify.designMode) {
          return;
        }

        let expires;

        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;

          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;

          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;

          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;

          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;

          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;

          case 'every_1_hr':
            expires = 1 / 24;
            break;

          case 'every_6_hrs':
            expires = 6 / 24;
            break;

          case 'every_12_hrs':
            expires = 1 / 2;
            break;

          case 'every_day':
            expires = 1;
            break;

          case 'every_3_days':
            expires = 3;
            break;

          case 'every_week':
            expires = 7;
            break;

          case 'every_2_weeks':
            expires = 14;
            break;

          case 'every_month':
            expires = 30;
            break;

          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(
          this.cookieName,
          {
            opened: true,
          },
          expires
        );
      }
    }
  );
}